import {useAppState} from "@/store";
import {buildDate, dateParts, formatPrice} from "@/helpers";

export default function RateChoice({availability}) {

    const {state, setState} = useAppState()

    if (!availability) {
        return
    }

    const selected = availability.date === state.chosen_date?.raw

    const formatted = dateParts(availability.date)

    const discounted = Boolean(availability.salePrice && parseFloat(availability.salePrice) < parseFloat(availability.basePrice))
    const discountAmt = discounted ? parseFloat(availability.basePrice) - parseFloat(availability.salePrice) : 0
    const price = discounted ? parseFloat(availability.salePrice) : parseFloat(availability.basePrice)

    const setChosenRate = () => {
        setState(s => {
            s.availability = availability
            s.chosen_date = buildDate(availability.date)
            s.chosen_rate = price
            s.chosen_time = null
        })
    }

    function RateNote() {
        if (selected) {
            return (
                <div className={"text-[13px] leading-[20px] mt-[8px] font-bold text-center"}>
                    You selected
                </div>
            )
        }
        if (discounted) {
            return (
                <div className={"text-[13px] leading-[20px] mt-[8px] font-bold text-center text-brand-blue"}>
                    🧡 Save {formatPrice(discountAmt)}
                </div>
            )
        }
    }

    return (
        <>
            <div
                className={"rounded-lg border-2 w-full flex flex-col items-center justify-center p-[16px] cursor-pointer transition-colors " + (selected ? 'bg-brand-orange text-white border-brand-orange' : 'border-brand-blue hover:bg-brand-orange/50 hover:border-brand-orange')}
                onClick={setChosenRate}
            >
                <div className="text-small font-bold">
                    {formatted.weekday} {formatted.day}
                </div>
                <div>
                    {formatPrice(price)}
                </div>
            </div>
            <RateNote/>
        </>
    )
}
